"use strict";
var $ = require("../internals/export");
$({ target: "Number", stat: true, nonConfigurable: true, nonWritable: true }, {
  EPSILON: Math.pow(2, -52)
});
